import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import AddEditAdhocCompany from "./addEdit";
import { useDispatch } from "react-redux";
import { archiveCompanyAdhoc, clearArchiveCompanyAdhoc } from "../../../../redux/AdhocCompany/Companyadhocslice";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const AdhocCompanyList = ({ data = [], loading, page, limit, onRefresh }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State for Edit/Dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isEdit, setIsEdit] = useState(false); // Track if it is edit mode
  const [isOpen, setIsOpen] = useState(false); // For Archive Modal
  const [archiveAction, setArchiveAction] = useState('archive');

  // Helper to calculate Serial Number
  const getSNo = (index) => {
    return String((page - 1) * limit + (index + 1)).padStart(2, "0");
  };

  // Handle Edit Click
  const handleEditClick = (item) => {
    setSelectedCompany(item); // Store the clicked item data
    setIsEdit(true);          // Set mode to Edit
    setDialogOpen(true);      // Open Modal
  };
  // 3. Handle Archive
  const handleArchive = async () => {
    if (selectedCompany) {
      try {
        const companyId = selectedCompany.company_id || selectedCompany.id;
        const isArchive = archiveAction === 'archive';
        const response = await dispatch(archiveCompanyAdhoc({ companyId, isArchive })).unwrap();
        const actionText = isArchive ? 'archived' : 'unarchived';
        SweetAlertService.showSuccess({
          icon: 'success',
          message: response?.message || `Company ${actionText} successfully`
        });
        setIsOpen(false);
        if (onRefresh) onRefresh();
      } catch (error) {
        SweetAlertService.showError({
          icon: 'error',
          message: error || `Failed to ${archiveAction} company`
        });
      } finally {
        dispatch(clearArchiveCompanyAdhoc());
        setSelectedCompany(null);
        setArchiveAction('archive');
      }
    }
  };

  return (
    <>
      <div className="border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr className="text-start">
              <Th className="text-start">S No.</Th>
              <Th className="text-start">Company Name</Th>
              <Th className="text-start">Contact Person</Th>
              <Th className="text-start">HR</Th>
              <Th className="text-start">HR Phone No</Th>
              <Th className="text-start">HR Email</Th>
              <Th className="text-start">Quota</Th>
              <Th className="text-start">Status</Th>
              <Th className="text-start">Action</Th>
            </Tr>
          </THead>

          <TBody>
            {loading ? (
              <Tr>
                <Td colSpan={9} className="py-10 text-center">
                  <ThreeDotBouncingLoader />
                </Td>
              </Tr>
            ) : data && data.length > 0 ? (
              data.map((item, index) => (
                <Tr key={item._id || item.id} className="text-start">
                  <Td className="text-start">{getSNo(index)}</Td>
                  {/* Mapping API keys to Table Cells */}
                  <Td className="text-start capitalize">{item.company_name || item.name || "-"}</Td>
                  <Td className="text-start capitalize">{item.contact_person || item.personIncharge || "-"}</Td>
                  <Td className="text-start capitalize">{item.hr?.first_name ? `${item.hr?.first_name} ${item.hr?.last_name || ''}` : item.hr || "-"}</Td>
                  <Td className="text-start">{item.hr?.mobile_number || item.hrPhoneNo || "-"}</Td>
                  <Td className="text-start">{item.hr?.email || item.hrEmail || "-"}</Td>
                  <Td className="text-start">{item.quota || "-"}</Td>
                  <Td className="text-start">
                    <span
                      className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${item.is_archived
                        ? "bg-slate-100 text-slate-700"
                        : "bg-green-100 text-green-800"
                        }`}
                    >
                      {item.is_archived ? "Archived" : "Active"}
                    </span>
                  </Td>
                  <Td className="text-start">
                    <div className="flex gap-1">
                      {/* View Button */}
                      <CommonIconButton
                      type="view"
                        onClick={() => navigate(`/adhoc-company/view?companyId=${item.company_id || item.id}&companyName=${item.company_name || item.name}`)}
                      />
                      

                      {/* Edit Button */}
                      {!item.is_archived && (
                        <CommonIconButton
                      type="edit"
                          onClick={() => handleEditClick(item)}
                        />
                     
                      )}

                      {/* Archive/Unarchive Button */}
                      <CommonIconButton
                        type={item.is_archived ? "unarchive" : "archive"}
                        onClick={() => {
                          setSelectedCompany(item);
                          setArchiveAction(item.is_archived ? 'unarchive' : 'archive');
                          setIsOpen(true);
                        }}
                      />
                     
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={9} className="text-center text-gray-500 py-6 text-sm">
                  {loading ? "Fetching data..." : "No matching records found"}
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>

      <AddEditAdhocCompany
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          setIsEdit(false);
          setSelectedCompany(null); // Clear selected data on close
          if (onRefresh) onRefresh(); // Refresh list on close
        }}
        individualData={selectedCompany} // Pass the selected data
        isEdit={isEdit} // Pass edit flag
      />

      <ArchiveModal
        dialogOpen={isOpen}
        onDialogClose={() => {
          setIsOpen(false);
          setSelectedCompany(null);
          setArchiveAction('archive');
        }}
        onConfirm={handleArchive}
        title={`Are you sure you want to ${archiveAction} this adhoc company?`}
        subtitle={`This will ${archiveAction === 'archive' ? 'hide' : 'restore'} the company in the active list.`}
      />
    </>
  );
};

export default AdhocCompanyList;